import { DiamondIcon } from "@phosphor-icons/react";
import { eliteCheck } from "../lib/elite";

const CYAN = "#22D3EE";

// Full elite badge (detail page) — shows only when all market criteria pass.
export const EliteBadge = ({ coin, compact = false }) => {
  const { isElite, criteria } = eliteCheck(coin);
  if (!isElite) return null;
  const title = "Elite setup — " + criteria.map((c) => `${c.label}: ${c.detail}`).join(" · ");
  return (
    <span
      data-testid="elite-badge"
      title={title}
      className={`inline-flex items-center gap-1 font-mono font-bold border ${compact ? "text-[10px] px-1.5 py-0.5" : "text-xs px-2 py-1"}`}
      style={{ color: CYAN, borderColor: `${CYAN}55`, background: `${CYAN}1a` }}
    >
      <DiamondIcon size={compact ? 11 : 13} weight="fill" /> ELITE
    </span>
  );
};

// Detailed checklist for the coin detail page.
export const EliteChecklist = ({ coin }) => {
  const { isElite, passCount, total, criteria } = eliteCheck(coin);
  return (
    <div data-testid="elite-checklist" className="border p-4 space-y-3" style={{ borderColor: isElite ? `${CYAN}55` : "rgba(255,255,255,0.1)", background: isElite ? `${CYAN}0d` : "transparent" }}>
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2 font-heading font-bold text-sm">
          <DiamondIcon size={18} weight="fill" style={{ color: CYAN }} />
          Elite Setup
        </div>
        <span className="font-mono text-xs" style={{ color: isElite ? CYAN : "#8b8b8b" }}>{passCount}/{total} criteria</span>
      </div>
      <div className="space-y-1.5">
        {criteria.map((c) => (
          <div key={c.key} className="flex items-center justify-between text-xs">
            <span className={c.pass ? "text-white" : "text-muted-foreground line-through"}>{c.label}</span>
            <span className="font-mono" style={{ color: c.pass ? CYAN : "#666" }}>{c.pass ? "✓" : "✕"} {c.detail}</span>
          </div>
        ))}
      </div>
      <p className="text-[11px] text-muted-foreground border-t border-white/10 pt-2">
        {isElite ? "Meets all market criteria. Confirm Mint Renounced + Freeze Disabled in Rug Forensics below to fully verify." : "Not yet elite — needs all market criteria above."}
      </p>
    </div>
  );
};
